<template>
  <transition :name="transitionName">
    <div v-show="model" :class="classes">
      <div :class="innerClasses" :style="styles"></div>
    </div>
  </transition>
</template>

<script>
import { PREFIX_CLASS } from '@/utils/constants'
const PREFIXCLS = `${PREFIX_CLASS}loading`
export default {
  // eslint-disable-next-line
  name: 'gloading',
  props: {
    transitionName: {
      type: String,
      default: 'fade'
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      prefixCls: PREFIXCLS,
      model: false,
      status: '',
      timer: null,
      percent: 0
    }
  },
  computed: {
    classes () {
      return [`${this.prefixCls}`, `${this.prefixCls}__bar`]
    },
    innerClasses () {
      return [
        `${this.prefixCls}__bar__inner`,
        {
          [`${this.prefixCls}__bar__inner--success`]: this.status === 'success',
          [`${this.prefixCls}__bar__inner--error`]: this.status === 'error'
        }
      ]
    },
    styles () {
      return {
        width: this.percent + '%'
      }
    }
  },
  mounted() {
    this.model = this.value
  },
  destroyed() {
    this.clearTimer()
  },
  methods: {
    start () {
      this.model = true
      this.status = 'success'
      if (this.timer) return
      this.percent = 0
      this.timer = setInterval(() => {
        this.percent += Math.floor(Math.random() * 3 + 5)
        if (this.percent > 95) {
          this.clearTimer()
        }
      }, 200)
    },
    finish () {
      this.model = true
      this.status = 'success'
      this.percent = 100
      this.hide()
    },
    error () {
      this.model = true
      this.status = 'error'
      this.percent = 100
      this.hide()
    },
    clearTimer () {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    hide () {
      this.model = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/loading/global-loading.vue